import { Chart } from "react-chartjs-2";
import { Chart as ChartJS, registerables } from "chart.js";
import { Chart as ChartModel } from "../../../utils/models";

import withChart from "../../hoc/withChart";

ChartJS.register(...registerables);

const Doughnut = (props: ChartModel): JSX.Element => {
  const options: any = {
    plugins: {
      labels: { render: "percentage", precision: 2 },
      datalabels: { display: true },
    },
  };

  return (
    <Chart
      ref={props.chartRef}
      type="doughnut"
      data={props.chartData}
      options={options}
    />
  );
};

export default withChart(Doughnut);
